import { createConfigProvider } from '@repo/ui'
import { Config, ConfigSchema } from '@/features/config/schema/Config'
import { getConfig } from '@/apis/Config'
import { setBaseUrl as setBackendBaseUrl } from '@/apis/clients/backendApiClient'
import { backendApi } from '@/apis/clients'
import { t } from 'i18next'

const { ConfigProvider, useConfig } = createConfigProvider<Config>({
  configSchema: ConfigSchema,
  getConfig,
  onConfigValidated: (config) => {
    if (backendApi.defaults.baseURL !== config.backendServiceUrl) {
      setBackendBaseUrl(config.backendServiceUrl)
    }
  },
  translations: {
    validationError: (error) =>
      t('init:configProvider.validationError', { error }),
    unknownError: () => t('init:configProvider.unknownError')
  }
})

export { ConfigProvider, useConfig }
